import { Adapter as r, getAdapter as t } from "../../../adapter.js";
import { CashbackAccountAdapter as c } from "../cashback/cashbackAccount/cashbackAccount.adapter.js";
import { ActivityModel as a } from "./activity.model.js";
class y extends r {
  adapt(e) {
    return new a(
      e.loyalty ? {
        code: e.loyalty.code,
        accumulatedBalance: e.loyalty.accumulated_balance,
        currentTierBalance: e.loyalty.current_tier_balance,
        currentTierName: e.loyalty.current_tier_name
      } : void 0,
      e.cashback ? t(c).adapt(e.cashback) : void 0
    );
  }
  serialize(e) {
  }
}
export {
  y as ActivityAdapter
};
//# sourceMappingURL=activity.adapter.js.map
